/**
 * Account Status Type
 * Represents the possible states an account can be in
 */
export type AccountStatus = 'verified' | 'unverified' | 'removed' | 'cancelled';

/**
 * Account Action Type
 * Represents actions that can be performed on an account
 */
export type AccountAction = 'verify' | 'activate' | 'cancel' | 'remove';

/**
 * HATEOAS Action Link from Backend
 * Represents a hypermedia link for an account action
 */
export interface AccountActionLink {
  href: string;
  title: string;
  method: string;
}

/**
 * Links Object per Account
 * Contains HATEOAS-style action links provided by backend
 */
export interface AccountLinks {
  self: string;
  verify?: AccountActionLink;
  cancel?: AccountActionLink;
  remove?: AccountActionLink;
  activate?: AccountActionLink;
}

/**
 * Type guard to check if a string is a valid AccountStatus
 */
export function isValidAccountStatus(status: string): status is AccountStatus {
  return ['verified', 'unverified', 'removed', 'cancelled'].includes(status);
}

/**
 * Get the display label for an account status
 */
export function getAccountStatusLabel(status: AccountStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}
